import type {ServerWebExchange} from '../../types/web/server';

import info from '@interopio/gateway-server/package.json' with {type: 'json'};

const serverHeader = (server?: string | false) => {
    server ??= `${info.name} - v${info.version}`;
    return async ({response}: ServerWebExchange, next: () => Promise<void>) => {
        if (server !== false && !response.headers.has('server')) {
            response.headers.set('Server', server);
        }
        await next();
    }
};

export default (server?: string | false) => serverHeader(server);
